

































import { Component, Vue } from 'vue-property-decorator';
import { I18n } from '@aws-amplify/core';
import { Auth } from '@aws-amplify/auth';
import { AmplifyEventBus } from 'aws-amplify-vue';
import {
  CognitoUserInterface,
  onAuthUIStateChange,
} from '@aws-amplify/ui-components';
import Layout from '@/layouts/Layout';
import dict from '@/components/authentication/AmplifyI18n';
import AuthGroup from '@/logic/auth/AuthGroup';
import LinkCorporate from '@/components/LinkCorporate.vue';
import SwitchLocale from '@/components/SwitchLocale.vue';

@Component({
  components: { LinkCorporate, SwitchLocale, Layout },
})
export default class Authentication extends Vue {
  user?: CognitoUserInterface;

  signedIn = false;

  mfaPreference: any = '';

  mfaConfig = {
    mfaTypes: ['TOTP'],
  };

  get authConfig(): any {
    const emailLabel = 'Email address';
    return {
      usernameAttributes: emailLabel,
      signUpConfig: {
        hideAllDefaults: true,
        signUpFields: [
          {
            label: emailLabel,
            key: 'username',
            required: true,
            displayOrder: 1,
            type: 'string',
          },
          {
            label: this.$t('registration.label.password'),
            key: 'password',
            required: true,
            displayOrder: 2,
            type: 'password',
          },
          {
            label: 'locale',
            key: 'locale',
            required: false,
            displayOrder: 3,
            type: 'string',
            value: this.$i18n.locale,
          },
        ],
      },
    };
  }

  get groups(): string[] {
    if (!this.user) {
      return [];
    }
    return this.user.signInUserSession.accessToken.payload['cognito:groups'];
  }

  get needsMFASetup(): boolean {
    return (
      // prettier-ignore
      this.memberOf(AuthGroup.Direct) && this.mfaPreference !== 'SOFTWARE_TOKEN_MFA'
    );
  }

  memberOf(group: string): boolean {
    return this.groups.includes(group);
  }

  async beforeCreate() {
    // Get user information with Auth.currentAuthenticatedUser ().
    // If not, set the authentication status to false
    try {
      this.user = await Auth.currentAuthenticatedUser();
      this.signedIn = true;
      this.mfaPreference = await Auth.getPreferredMFA(this.user, {
        bypassCache: false,
      });
    } catch (err) {
      this.signedIn = false;
      this.user = undefined;
    }
    // Register the event to be called when the authentication status changes
    AmplifyEventBus.$on('authState', async (info: any) => {
      if (info === 'signedIn') {
        this.user = await Auth.currentAuthenticatedUser();
        this.signedIn = true;
        this.mfaPreference = await Auth.getPreferredMFA(this.user, {
          bypassCache: false,
        });
      } else {
        this.signedIn = false;
        this.user = undefined;
      }
    });
  }

  beforeDestroy() {
    return onAuthUIStateChange;
  }

  mounted() {
    this.setSignUp();

    I18n.putVocabularies(dict);

    this.$watch(
      '$i18n.locale',
      (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        I18n.setLanguage(newLocale);
      },
      { immediate: true },
    );
  }

  // Set sign in or sign up manually, as the legacy component does not
  // have initialState.
  setSignUp() {
    if (this.$route.query.state !== 'signUp') {
      return;
    }
    setTimeout(() => {
      const link: any = document.querySelector(
        '[data-test="sign-in-create-account-link"]',
      );
      if (link) {
        link.click();
      }
    }, 0);
  }
}
